export var OpenThermStatusFlag;
(function (OpenThermStatusFlag) {
    OpenThermStatusFlag["f"] = "f";
    OpenThermStatusFlag["ch"] = "ch";
    OpenThermStatusFlag["dhw"] = "dhw";
    OpenThermStatusFlag["fl"] = "fl";
    OpenThermStatusFlag["cl"] = "cl";
    OpenThermStatusFlag["ch2"] = "ch2";
    OpenThermStatusFlag["di"] = "di";
})(OpenThermStatusFlag || (OpenThermStatusFlag = {}));
export var OpenThermFaultFlag;
(function (OpenThermFaultFlag) {
    OpenThermFaultFlag["sr"] = "sr";
    OpenThermFaultFlag["lr"] = "lr";
    OpenThermFaultFlag["wp"] = "wp";
    OpenThermFaultFlag["gf"] = "gf";
    OpenThermFaultFlag["ap"] = "ap";
    OpenThermFaultFlag["wot"] = "wot";
    OpenThermFaultFlag["reserve6"] = "reserve6";
    OpenThermFaultFlag["reserve7"] = "reserve7";
})(OpenThermFaultFlag || (OpenThermFaultFlag = {}));
export var OpenThermSlaveConfigurationFlag;
(function (OpenThermSlaveConfigurationFlag) {
    OpenThermSlaveConfigurationFlag["dhw"] = "dhw";
    OpenThermSlaveConfigurationFlag["ct"] = "ct";
    OpenThermSlaveConfigurationFlag["cc"] = "cc";
    OpenThermSlaveConfigurationFlag["dhwc"] = "dhwc";
    OpenThermSlaveConfigurationFlag["mpf"] = "mpf";
    OpenThermSlaveConfigurationFlag["ch2"] = "ch2";
})(OpenThermSlaveConfigurationFlag || (OpenThermSlaveConfigurationFlag = {}));
export var RemoteOverrideFlag;
(function (RemoteOverrideFlag) {
    RemoteOverrideFlag["mcp"] = "mcp";
    RemoteOverrideFlag["pcp"] = "pcp";
})(RemoteOverrideFlag || (RemoteOverrideFlag = {}));
export var OpenThermVariableName;
(function (OpenThermVariableName) {
    OpenThermVariableName["s"] = "s";
    OpenThermVariableName["cs"] = "cs";
    OpenThermVariableName["ff"] = "ff";
    OpenThermVariableName["rbp"] = "rbp";
    OpenThermVariableName["cs2"] = "cs2";
    OpenThermVariableName["odc"] = "odc";
    OpenThermVariableName["sc"] = "sc";
    OpenThermVariableName["mv"] = "mv";
    OpenThermVariableName["sv"] = "sv";
    OpenThermVariableName["rp"] = "rp";
    OpenThermVariableName["rml"] = "rml";
    OpenThermVariableName["wp"] = "wp";
    OpenThermVariableName["fr"] = "fr";
    OpenThermVariableName["rsp2"] = "rsp2";
    OpenThermVariableName["rt"] = "rt";
    OpenThermVariableName["bt"] = "bt";
    OpenThermVariableName["dt"] = "dt";
    OpenThermVariableName["ot"] = "ot";
    OpenThermVariableName["rwt"] = "rwt";
    OpenThermVariableName["sst"] = "sst";
    OpenThermVariableName["sct"] = "sct";
    OpenThermVariableName["ft2"] = "ft2";
    OpenThermVariableName["dt2"] = "dt2";
    OpenThermVariableName["et"] = "et";
    OpenThermVariableName["bs"] = "bs";
    OpenThermVariableName["ps"] = "ps";
    OpenThermVariableName["dps"] = "dps";
    OpenThermVariableName["dbs"] = "dbs";
    OpenThermVariableName["bh"] = "bh";
    OpenThermVariableName["ph"] = "ph";
    OpenThermVariableName["dph"] = "dph";
    OpenThermVariableName["dbh"] = "dbh";
    OpenThermVariableName["db"] = "db";
    OpenThermVariableName["b"] = "b";
    OpenThermVariableName["mrml"] = "mrml";
    OpenThermVariableName["ds"] = "ds";
    OpenThermVariableName["ms"] = "ms";
    OpenThermVariableName["cc"] = "cc";
    OpenThermVariableName["bcml"] = "bcml";
    OpenThermVariableName["rors"] = "rors";
    OpenThermVariableName["rof"] = "rof";
})(OpenThermVariableName || (OpenThermVariableName = {}));
export const OT_ID = {
    [OpenThermVariableName.s]: 0,
    [OpenThermVariableName.cs]: 1,
    [OpenThermVariableName.ff]: 5,
    [OpenThermVariableName.rbp]: 6,
    [OpenThermVariableName.cs2]: 8,
    [OpenThermVariableName.odc]: 115,
    [OpenThermVariableName.sc]: 3,
    [OpenThermVariableName.mv]: 126,
    [OpenThermVariableName.sv]: 127,
    [OpenThermVariableName.rp]: 16,
    [OpenThermVariableName.rml]: 17,
    [OpenThermVariableName.wp]: 18,
    [OpenThermVariableName.fr]: 19,
    [OpenThermVariableName.rsp2]: 23,
    [OpenThermVariableName.rt]: 24,
    [OpenThermVariableName.bt]: 25,
    [OpenThermVariableName.dt]: 26,
    [OpenThermVariableName.ot]: 27,
    [OpenThermVariableName.rwt]: 28,
    [OpenThermVariableName.sst]: 29,
    [OpenThermVariableName.sct]: 30,
    [OpenThermVariableName.ft2]: 31,
    [OpenThermVariableName.dt2]: 32,
    [OpenThermVariableName.et]: 33,
    [OpenThermVariableName.bs]: 116,
    [OpenThermVariableName.ps]: 117,
    [OpenThermVariableName.dps]: 118,
    [OpenThermVariableName.dbs]: 119,
    [OpenThermVariableName.bh]: 120,
    [OpenThermVariableName.ph]: 121,
    [OpenThermVariableName.dph]: 122,
    [OpenThermVariableName.dbh]: 123,
    [OpenThermVariableName.db]: 48,
    [OpenThermVariableName.b]: 49,
    [OpenThermVariableName.mrml]: 14,
    [OpenThermVariableName.bcml]: 15,
    [OpenThermVariableName.ds]: 56,
    [OpenThermVariableName.ms]: 57,
    [OpenThermVariableName.cc]: 7,
    [OpenThermVariableName.rors]: 9,
    [OpenThermVariableName.rof]: 100,
};
export const OpenThermStateTranslate = {
    [OpenThermVariableName.s]: { en: 'Status Flags', ru: 'Статус' },
    [OpenThermVariableName.cs]: {
        en: 'Control Setpoint',
        ru: 'Расчётная t° теплоносителя',
    },
    [OpenThermVariableName.ff]: { en: 'Fault flags', ru: 'Флаги ошибки' },
    [OpenThermVariableName.rbp]: {
        en: 'Remote Boiler Parameters',
        ru: 'Статус котла',
    },
    [OpenThermVariableName.cs2]: {
        en: 'Control Setpoint 2',
        ru: 'Расчётная t° теплоносителя 2',
    },
    [OpenThermVariableName.odc]: { en: 'OEM diagnostic code', ru: 'Код ошибки' },
    [OpenThermVariableName.sc]: { en: 'boiler configuration', ru: 'Конфигурация котла' },
    [OpenThermVariableName.mv]: { en: 'master version', ru: 'Версия термостата' },
    [OpenThermVariableName.sv]: { en: 'boiler version', ru: 'Версия котла' },
    [OpenThermVariableName.rp]: { en: 'Room setpoint', ru: 'Расчётная t° комнаты' },
    [OpenThermVariableName.rml]: {
        en: 'Relative modulation level',
        ru: 'Уровень модуляции',
    },
    [OpenThermVariableName.wp]: { en: 'Water pressure', ru: 'Давление теплоносителя' },
    [OpenThermVariableName.fr]: { en: 'DHW speed', ru: 'Скорость потока ГВС' },
    [OpenThermVariableName.rsp2]: { en: 'Room setpoint 2', ru: 'Расчётная t° комнаты 2' },
    [OpenThermVariableName.rt]: { en: 'Room temperature', ru: 'Комнатная t°' },
    [OpenThermVariableName.bt]: {
        en: 'Boiler water temperature',
        ru: 'Фактическая t° теплоносителя',
    },
    [OpenThermVariableName.dt]: { en: 'DHW temperature', ru: 'Фактическая t° ГВС' },
    [OpenThermVariableName.ot]: { en: 'Outside temperature', ru: 't° вне дома' },
    [OpenThermVariableName.rwt]: {
        en: 'Return water temperature',
        ru: 't° обратного потока',
    },
    [OpenThermVariableName.sst]: {
        en: 'Solar storage temperature',
        ru: 't° солнечного накопителя',
    },
    [OpenThermVariableName.sct]: {
        en: 'Solar collector temperature',
        ru: 't° солнечного коллектора',
    },
    [OpenThermVariableName.ft2]: {
        en: 'Flow temperature CH2',
        ru: 't° потока теплоносителя 2',
    },
    [OpenThermVariableName.dt2]: { en: 'DHW2 temperature', ru: 'Фактическая t° ГВС 2' },
    [OpenThermVariableName.et]: {
        en: 'Exhaust temperature',
        ru: 't° выхлопа',
    },
    [OpenThermVariableName.bs]: { en: 'Burner starts', ru: 'Запуск горелки' },
    [OpenThermVariableName.ps]: {
        en: 'CH pump starts',
        ru: 'Запуск насоса теплоносителя',
    },
    [OpenThermVariableName.dps]: {
        en: 'DHW pump/valve starts',
        ru: 'Запуск насоса ГВС насос/значение',
    },
    [OpenThermVariableName.dbs]: { en: 'DHW burder starts', ru: 'Запуск горелки ГВС' },
    [OpenThermVariableName.bh]: {
        en: 'Burner operation hours',
        ru: 'Часы работы горелки',
    },
    [OpenThermVariableName.ph]: {
        en: 'CH pump operation hours',
        ru: 'Часы работы насоса теплоносителя',
    },
    [OpenThermVariableName.dph]: {
        en: 'DHW pump/valve operation hours',
        ru: 'Часы работы ГВС насос/значение',
    },
    [OpenThermVariableName.dbh]: {
        en: 'DHW burner operation hours',
        ru: 'Часы работы горелки ГВС',
    },
    [OpenThermVariableName.db]: {
        en: 'Bounds for adjustment of DHW setpoint',
        ru: 'Границы t° ГВС',
    },
    [OpenThermVariableName.b]: {
        en: 'Bounds for adjustment of CH setpoint',
        ru: 'Границы t° теплоносителя',
    },
    [OpenThermVariableName.mrml]: {
        en: 'Maximum relative modulation level',
        ru: 'Максимальный уровень модуляции',
    },
    [OpenThermVariableName.bcml]: {
        en: 'Maximum boiler capacity & minimum modulation level',
        ru: 'Максимальная вместимость котла и минимальный уровень модуляции',
    },
    [OpenThermVariableName.ds]: { en: 'DHW setpoint', ru: 'Расчётная t° ГВС' },
    [OpenThermVariableName.ms]: {
        en: 'max CH water setpoint',
        ru: 'Максимальная расчетная t° теплоносителя ',
    },
    [OpenThermVariableName.cc]: {
        en: 'Cooling control signal',
        ru: 'Сигнал управления охлаждением',
    },
    [OpenThermVariableName.rors]: {
        en: 'Remote override room setpoint',
        ru: 'Расчётная t° в комнате',
    },
    [OpenThermVariableName.rof]: {
        en: 'Remote override function',
        ru: 'Функция дистанционного управления',
    },
    [OpenThermStatusFlag.f]: { en: 'Fault indication', ru: 'Ошибка' },
    [OpenThermStatusFlag.ch]: { en: 'Central Heating mode', ru: 'Отопление' },
    [OpenThermStatusFlag.fl]: { en: 'Flame on/off', ru: 'Горелка' },
    [OpenThermStatusFlag.cl]: { en: 'Cooling mode', ru: 'Охлаждение' },
    //они тут, т.к. перезатирают полезные флаги
    [OpenThermSlaveConfigurationFlag.dhw]: { en: 'DHW present', ru: undefined },
    [OpenThermSlaveConfigurationFlag.ch2]: { en: 'CH2 present', ru: undefined },
    //-------------------------
    //@ts-ignore
    [OpenThermStatusFlag.dhw]: { en: 'DHW mode', ru: 'ГВС' },
    //@ts-ignore
    [OpenThermStatusFlag.ch2]: { en: 'Central Heating 2 mode', ru: '2 контур отопления' },
    [OpenThermStatusFlag.di]: {
        en: 'Diagnostic indication',
        ru: 'Диагностическое сообщение',
    },
    [OpenThermFaultFlag.sr]: { en: 'Service request', ru: 'Необходимо обслуживание' },
    [OpenThermFaultFlag.lr]: { en: 'Lockout-reset', ru: 'Требуется ручной сброс' },
    //@ts-ignore
    [OpenThermFaultFlag.wp]: { en: 'Water pressure', ru: 'Давление теплоносителя' },
    [OpenThermFaultFlag.gf]: { en: 'Gas/flame fault', ru: 'Сбой газа/горелки' },
    [OpenThermFaultFlag.ap]: { en: 'Air pressure fault', ru: 'Сбой давления воздуха' },
    [OpenThermFaultFlag.wot]: {
        en: 'Water over-temperature',
        ru: 'Превышение температуры',
    },
    [OpenThermSlaveConfigurationFlag.ct]: { en: 'Control type', ru: 'Тип контроля' },
    //@ts-ignore
    [OpenThermSlaveConfigurationFlag.cc]: {
        en: 'Cooling config',
        ru: 'Конфигурация охлаждения',
    },
    [OpenThermSlaveConfigurationFlag.dhwc]: { en: 'DHW config', ru: 'Конфигурация ГВС' },
    [OpenThermSlaveConfigurationFlag.mpf]: {
        en: 'Master low-off & pump control function',
        ru: 'Контроль насоса',
    },
    [RemoteOverrideFlag.mcp]: { en: 'Manual change priority', ru: undefined },
    [RemoteOverrideFlag.pcp]: { en: 'Program change priority', ru: undefined },
    [OpenThermFaultFlag.reserve6]: { en: undefined, ru: undefined },
    [OpenThermFaultFlag.reserve7]: { en: undefined, ru: undefined },
};
export function getOpenThermStateName(ot, language = 'ru') {
    const parameter = OpenThermStateTranslate[ot];
    if (!parameter) {
        return ot;
    }
    return parameter[language] ?? `Не нашёл название для флага ${ot}`;
}
